import { useTranslation } from 'react-i18next';
import { TRACK } from '@/track/track.constants';
import { doTrack } from '@/track/track.service';
import { Modal } from '@seeqdev/qomponents';

interface CloseWhileSavingModalProps {
  onClose: () => void;
}

export const ClosedWhileSavingModal = ({ onClose }: CloseWhileSavingModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={true}
      title={t('ITEM_ACL.CLOSE_DURING_SAVE.HEADER')}
      hideSubmitButton={true}
      cancelButtonLabel={t('ITEM_ACL.CLOSE_DURING_SAVE.CLOSE')}
      onClose={() => {
        doTrack(TRACK.ACCESS_CONTROL, 'close during save', 'close');
        onClose();
      }}
      onSubmit={() => {}}>
      <div>{t('ITEM_ACL.CLOSE_DURING_SAVE.MESSAGE')}</div>
    </Modal>
  );
};
